import CommonHeader from '../components/common/CommonHeader';
import CommonFooter from '../components/common/CommonFooter';
import SearchBox from '../components/common/SearchBox';
import SwitchSortType from '../components/common/SwitchSortType';
import Meta from '../components/common/Meta';
import BlogCardList from '../components/blogs/BlogCardList';

const meta = {
    title: '博客广场 - 博客中心',
    keywords: '博客, 博友, 博客圈, 博客中心, 朋友圈, 收录, RSS, 聚合, 中文, 独立博客',
    description: '展示博客中心所收录的全部博客。',
};

const switchTypes = [
    { name: '最近收录', href: '/blogs', default: true },
    { name: '最多浏览', href: '/blogs?sort=access_count', default: false },
    { name: '最长博龄', href: '/blogs?sort=create_time', default: false },
];

export default function BlogsPage() {
    return (
        <div className="redesign-page">
            <Meta meta={meta} />
            <CommonHeader />
            <main>
                <div className="redesign-container">
                    <header className="redesign-page-header">
                        <h1 className="redesign-page-title">博客广场</h1>
                        <p className="redesign-page-desc">
                            欢迎来博客广场发现好博客！这里收录了中文独立博客，按收录时间、浏览量、博龄等维度浏览。
                        </p>
                    </header>

                    <SearchBox placeholder="搜索博客…" gotoPage="/blogs" />
                    <SwitchSortType types={switchTypes} />
                    <BlogCardList />
                </div>
            </main>
            <CommonFooter />
        </div>
    );
}
